module.exports = __webpack_public_path__ + "img/arrow.a0070904.svg";